<template>
  <v-dialog v-model="isShow" width="600">
    <v-card>
      <v-card-text class="text-xs-right">
        <v-btn fab small flat class="ma-0 extra-small" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-text>
      <slot name="body"></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return { isShow: false }
  },
  mounted: function () {
    let vm = this
    vm.isShow = vm.value
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  watch: {
    value: function (newVal) {
      var vm = this

      vm.isShow = newVal
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/PreviewImage.vue